module.exports = false;


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/taxpadweb/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 1